import React, { useEffect } from "react";
import { navigate } from "gatsby";
import { useFormContext } from "../context/FormContext";
import { REDIRECT_AFTER_MS } from "../../constants";
import { FF2EventName, trackFF2Event } from "../analytics";
import { Spinner } from "../../../Spinner";

export const RedirectToMortgageComparison: React.FC = () => {
  const { formData } = useFormContext();

  useEffect(() => {
    trackFF2Event(FF2EventName.REDIRECT_MORTGAGE_COMPARISON, formData);

    setTimeout(() => {
      navigate("/mortgages/mortgage-comparison");
    }, REDIRECT_AFTER_MS);
  }, []);

  return (
    <div className="heroff2-form">
      <h2>Thank you.</h2>
      <h2>
        You will be redirected to our mortgage comparison page in
        {" "}
        {REDIRECT_AFTER_MS / 1000}
        {" "}
        seconds...
      </h2>
      <Spinner />
    </div>
  );
};
